import Vue from 'vue'
import Vuex from 'vuex'
import data from './modules/data'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    data
  },
  getters
})
